module.exports = __webpack_public_path__ + "img/tab_item.a8156aec.png";